/* ============================================
   DT MEGA PRODUCT SLIDER — JS finale
   assets/dt-mega-product-slider.js
   ============================================ */

(function () {
  'use strict';

  /* ---------- PANEL POSITION FIX ----------
     Il tema (dt-mega-menu.js) posiziona il pannello con
     left/width assoluti calcolati su una larghezza fissa.
     Su viewport più piccole (1440px) il pannello sfora.
     Lo forziamo a coprire esattamente la viewport.

     Usiamo un flag _fixing per evitare loop infiniti
     con il MutationObserver sullo style. */

  var _fixing = false;

  function fixPanelPosition() {
    var panel = document.querySelector('.dt-mega-slider-dynamic');
    if (!panel) return;

    var cs = window.getComputedStyle(panel);
    if (cs.display === 'none' || cs.visibility === 'hidden') return;

    var li = panel.closest('li');
    if (!li) return;

    var liRect = li.getBoundingClientRect();
    var targetLeft = -liRect.left;
    var targetWidth = window.innerWidth;

    // Controlla se serve un fix
    var currentWidth = panel.getBoundingClientRect().width;
    if (Math.abs(currentWidth - targetWidth) < 2) return;

    _fixing = true;
    panel.style.setProperty('left', targetLeft + 'px', 'important');
    panel.style.setProperty('width', targetWidth + 'px', 'important');

    // Reset flag dopo che il browser ha applicato lo stile
    requestAnimationFrame(function () {
      _fixing = false;
    });
  }

  /* ---------- ITEM WIDTH (dinamica) ---------- */

  function getItemWidth(track) {
    var item = track.querySelector('.dt-henriot__item');
    if (!item) return 170;
    var rect = item.getBoundingClientRect();
    var style = window.getComputedStyle(item);
    var marginLeft = parseFloat(style.marginLeft) || 0;
    var marginRight = parseFloat(style.marginRight) || 0;
    return rect.width + marginLeft + marginRight;
  }

  /* ---------- VISIBLE COUNT ---------- */

  function getVisible(container, itemW) {
    return Math.max(1, Math.floor(container.offsetWidth / itemW));
  }

  /* ---------- INIT SLIDER ---------- */

  function initSlider(mega) {
    var track    = mega.querySelector('.dt-henriot__track');
    var overflow = mega.querySelector('.dt-henriot__overflow');
    var prev     = mega.querySelector('.dt-henriot__arrow--prev');
    var next     = mega.querySelector('.dt-henriot__arrow--next');
    if (!track || !overflow || !prev || !next) return;

    var items   = track.querySelectorAll('.dt-henriot__item');
    var total   = items.length;
    var current = 0;

    function update() {
      fixPanelPosition();

      var itemW  = getItemWidth(track);
      var vis    = getVisible(overflow, itemW);
      var maxIdx = Math.max(0, total - vis);
      current    = Math.min(current, maxIdx);
      track.style.transform = 'translateX(-' + (current * itemW) + 'px)';
      prev.disabled = current === 0;
      next.disabled = current >= maxIdx;
    }

    prev.addEventListener('click', function () {
      current = Math.max(0, current - 1);
      update();
    });

    next.addEventListener('click', function () {
      var itemW  = getItemWidth(track);
      var vis    = getVisible(overflow, itemW);
      var maxIdx = Math.max(0, total - vis);
      current    = Math.min(maxIdx, current + 1);
      update();
    });

    current = 0;
    update();

    // Debounced resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 80);
    }, { passive: true });

    /* Osserva cambiamenti di stile sul pannello.
       Il tema (dt-mega-menu.js) sovrascrive left/width
       quando il menu si apre. Lo intercettiamo e correggiamo.
       Il flag _fixing evita loop infiniti. */
    var panel = document.querySelector('.dt-mega-slider-dynamic');
    if (panel) {
      new MutationObserver(function () {
        if (_fixing) return;
        setTimeout(function () {
          fixPanelPosition();
          // Ricalcola lo slider dopo il fix
          var itemW = getItemWidth(track);
          var vis = getVisible(overflow, itemW);
          var maxIdx = Math.max(0, total - vis);
          current = Math.min(current, maxIdx);
          track.style.transform = 'translateX(-' + (current * itemW) + 'px)';
          prev.disabled = current === 0;
          next.disabled = current >= maxIdx;
        }, 30);
      }).observe(panel, { attributes: true, attributeFilter: ['style'] });
    }
  }

  /* ---------- INIT ---------- */

  function init() {
    document.querySelectorAll('[data-mega-slider]').forEach(function (el) {
      initSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();